<small class="text-muted" translate>* Indicates required field</small>